export default __webpack_public_path__ + "static/media/ads_image.b2dbbd17.png";